import(/* webpackMode: "eager" */ "/app/src/app/[locale]/privacy/page.tsx");
